import React, { Children } from 'react';
import styled from 'styled-components';
import { STATES } from '../constants';
import Connector from './Connector';

const StepperContainer = styled.div`
  display: flex;
  width: 100%;
  align-items: flex-start;
`;

const StepWrapper = styled.div`
  display: flex;
  position: relative;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: ${({ numOfSteps }) => `calc(100% / ${numOfSteps})`};
`;

const getIsCompleted = (currentIndex, stepIndex) => stepIndex < currentIndex;
const getIsActive = (currentIndex, stepIndex) => stepIndex === currentIndex;

const getState = (stepProps, currentIndex, stepIndex) => {
  const isCompleted = getIsCompleted(currentIndex, stepIndex);
  const isActive = getIsActive(currentIndex, stepIndex);

  const disabled = !!stepProps[STATES.DISABLED];
  const error = !disabled && !!stepProps[STATES.ERROR] && isCompleted;
  const completed = !disabled && isCompleted;
  const active = !disabled && isActive;
  const incomplete = !disabled && !isActive && !isCompleted;

  return {
    [STATES.DISABLED]: disabled,
    [STATES.ERROR]: error,
    [STATES.COMPLETED]: completed,
    [STATES.ACTIVE]: active,
    [STATES.INCOMPLETE]: incomplete,
  };
};

const Stepper = ({ activeStepIdx = 0, children, className, shouldShowStepsConnector = true }) => (
  <StepperContainer className={className}>
    {Children.toArray(children).map((step, index, array) => {
      const state = getState(step.props, activeStepIdx, index);

      return (
        <StepWrapper key={`${step.props.label}_${index}`} numOfSteps={array.length}>
          {shouldShowStepsConnector && index !== 0 && <Connector {...state} key={`${step.props.label}_${index}`} />}
          {React.cloneElement(step, { ...step.props, ...state })}
        </StepWrapper>
      );
    })}
  </StepperContainer>
);

export default React.memo(Stepper);
